
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-2bdf7d6a\",\"scoped\":true,\"hasInlineConfig\":false}!./ChatPanel.css")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ChatPanel.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-2bdf7d6a\",\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChatPanel.vue"),
  /* scopeId */
  "data-v-2bdf7d6a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/entry-points/create-new-entry-point/chat-panel/ChatPanel.vue
// module id = 4s2w
// module chunks = 1